<script lang="js" setup>
import { useLocalePath } from '#imports'
import { useBackUrl } from '~/hooks/index.js'

const localePath = useLocalePath()
</script>

<template>
  <div class="text-xs font-medium text-textPrimary text-center">
    <i18n-t keypath="您还没有登录,请 {0} 或 {1} 后操作" scope="global" tag="div">
      <a class="text-buy" :href="useBackUrl(localePath('/log-in'))">{{ $t('登录') }}</a>
      <a class="text-buy" :href="useBackUrl(localePath('/sign-up'))">{{ $t('注册') }}</a>
    </i18n-t>
  </div>
</template>
